export const LINK_URL =  process.env.NODE_ENV === 'production' ? 
  'https://admin-responda-aqui.web.app/' : 
  'https://data-servey-dev.web.app/';